export default "__VITE_ASSET__gnLX3xps__"